import React from "react";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PhoneIcon from "@material-ui/icons/Phone";
import PublicIcon from "@material-ui/icons/Public";
import StreetviewIcon from "@material-ui/icons/Streetview";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
// import CardMembershipIcon from "@material-ui/icons/CardMembership";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { TagFaces } from "@material-ui/icons";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import BusinessIcon from "@material-ui/icons/Business";
import WorkIcon from "@material-ui/icons/Work";
import DnsIcon from "@material-ui/icons/Dns";
import SchoolIcon from "@material-ui/icons/School";
import Country from "./countryList";
import YearList from "./years";
import SchoolCoutry from "./schoolCountry";

let FormData = {
  personalInformation: {
    ses_applicant: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Applicant ID",
        autoComplete: "Applicant ID",
        name: "ses_applicant",
        disabled: true,
        fullWidth: true,
      },
      maxLength: 50,
      icon: <PermContactCalendarIcon style={{ color: "#959595" }} />,
      value: "",
    },
    firstname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "First Name",
        autoComplete: "first-name",
        name: "firstname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      maxLength: 50,
      isValid: false,
      errorMessage: "First Name can't be blank",
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    middlename: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Middle Name",
        autoComplete: "middle-name",
        name: "middlename",
        fullWidth: true,
        disabled: true,
      },
      maxLength: 50,
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    lastname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Last Name",
        autoComplete: "last-name",
        name: "lastname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      maxLength: 50,
      isValid: false,
      errorMessage: "Last Name can't be blank",
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    gendercode: {
      elementType: "select",
      elementConfig: {
        label: "Gender *",
        required: true,
        options: [],
        name: "gendercode",
      },
      value: 1,
    },
    birthdate: {
      elementType: "date",
      elementConfig: {
        label: "Date Of Birth* (DD/MM/YYYY)",
        name: "birthdate",
        id: "time-picker",
        fullWidth: true,
        InputLabelProps: {
          shrink: true,
        },
      },
      value: "",
    },
    address1_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street Address",
        autoComplete: "Street",
        name: "address1_line1",
        required: true,
        fullWidth: true,
      },
      maxLength: 250,
      isValid: false,
      errorMessage: "Street Address can't be blank",
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address1_city",
        required: true,
        fullWidth: true,
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "City can't be blank",
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_country: {
      elementType: "select",
      elementConfig: {
        label: "Country",
        name: "address1_country",
        required: true,
        options: [],
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "Country can't be blank",
      icon: <PublicIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address1_postalcode",
        fullWidth: true,
      },
      maxLength: 20,
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },

  contactInformation: {
    mobilePhone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Mobile Phone",
        name: "address1_telephone1",
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
    homePhone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Home Phone",
        name: "telephone2",
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  education: {
    Undergraduate: {
      ses_previousschool: {
        elementType: "input",
        elementConfig: {
          type: "text",
          label: "Secondary School",
          autoComplete: "Secondary-School",
          name: "ses_previousschool",
          required: true,
          fullWidth: true,
        },
        maxLength: 100,
        isValid: false,
        errorMessage: "Secondary School can't be blank",
        icon: <SchoolIcon style={{ color: "#959595" }} />,
        value: "",
      },
      ses_country: {
        elementType: "select",
        elementConfig: {
          label: "Country*",
          options: SchoolCoutry,
          name: "ses_country",
        },
        value: "",
      },
      ses_graduationyear: {
        elementType: "select",
        elementConfig: {
          label: "Graduation Year*",
          options: YearList,
          name: "ses_graduationyear",
        },
        value: 2020,
      },
      ses_schoolcontact: {
        elementType: "input",
        elementConfig: {
          type: "text",
          label: "Faculty",
          autoComplete: "Faculty",
          name: "ses_schoolcontact",
          required: true,
          fullWidth: true,
        },
        maxLength: 30,
        isValid: false,
        errorMessage: "Faculty can't be blank",
        icon: <SchoolIcon style={{ color: "#959595" }} />,
        value: "",
      },
      _ses_track_value: {
        elementType: "select",
        elementConfig: {
          label: "Preferred Major*",
          options: [],
          name: "_ses_track_value",
        },
        value: "",
      },
      ses_certificateearned: {
        elementType: "input",
        elementConfig: {
          type: "text",
          label: "Other Certificate",
          autoComplete: "Other Certificate",
          name: "ses_certificateearned",
          fullWidth: true,
        },
        maxLength: 100,
        icon: <CardGiftcardIcon style={{ color: "#959595" }} />,
        value: "",
      },
    },
    graduate: {
      prevEducation: {
        ses_previousschool: {
          elementType: "input",
          elementConfig: {
            type: "text",
            label: "University",
            autoComplete: "University",
            name: "ses_previousschool",
            required: true,
            fullWidth: true,
          },
          maxLength: 100,
          isValid: false,
          errorMessage: "Secondary School can't be blank",
          icon: <SchoolIcon style={{ color: "#959595" }} />,
          value: "",
        },
        // ses_city: {
        //   elementType: "input",
        //   elementConfig: {
        //     type: "text",
        //     label: "City",
        //     autoComplete: "City",
        //     name: "ses_city",
        //     required: true,
        //     fullWidth: true,
        //   },
        //   maxLength: 100,
        //   isValid: false,
        //   errorMessage: "City can't be blank",
        //   icon: <LocationCityIcon style={{ color: "#959595" }} />,
        //   value: "",
        // },
        ses_country: {
          elementType: "select",
          elementConfig: {
            label: "Country*",
            options: SchoolCoutry,
            name: "ses_country",
          },
          value: "",
        },
        ses_graduationyear: {
          elementType: "select",
          elementConfig: {
            label: "Graduation Year*",
            options: YearList,
            name: "ses_graduationyear",
          },
          value: 2020,
        },

        ses_schoolcontact: {
          elementType: "input",
          elementConfig: {
            type: "text",
            label: "Faculty",
            autoComplete: "Faculty",
            name: "ses_schoolcontact",
            required: true,
            fullWidth: true,
          },
          maxLength: 30,
          isValid: false,
          errorMessage: "Faculty can't be blank",
          icon: <SchoolIcon style={{ color: "#959595" }} />,
          value: "",
        },
      },

      prevEmployment: {
        ses_employer: {
          elementType: "input",
          elementConfig: {
            type: "text",
            label: "Company Name",
            autoComplete: "Company-Name",
            name: "ses_employer",
            required: true,
            fullWidth: true,
          },
          maxLength: 30,
          isValid: false,
          errorMessage: "Company Name can't be blank",
          icon: <BusinessIcon style={{ color: "#959595" }} />,
          value: "",
        },
        ses_previousemployment: {
          elementType: "input",
          elementConfig: {
            type: "text",
            label: "Job Title",
            autoComplete: "Job-Title",
            name: "ses_previousemployment",
            required: true,
            fullWidth: true,
          },
          maxLength: 30,
          isValid: false,
          errorMessage: "Job Title can't be blank",
          icon: <WorkIcon style={{ color: "#959595" }} />,
          value: "",
        },
        ses_startdate: {
          elementType: "exactDate",
          elementConfig: {
            label: "Hiring Date* (DD/MM/YYYY)",
            name: "ses_startdate",
            id: "time-picker",
            fullWidth: true,
          },
          value: "",
        },
      },
    },
  },

  emergenencyContact: {
    name: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Name",
        autoComplete: "name",
        name: "ses_emergencycontactname",
        required: true,
        fullWidth: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    relationship: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Relationship",
        autoComplete: "Relationship",
        name: "ses_emergencycontactrelationship",
        required: true,
        fullWidth: true,
      },
      icon: <TagFaces style={{ color: "#959595" }} />,
      value: "",
    },
    phone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Emergency Contact Number",
        autoComplete: "mobile-phone",
        name: "ses_emergencycontactphone",
        required: true,
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  miscellanous: {
    contactMode: {
      elementType: "select",
      elementConfig: {
        label: "Preferred Method of Contact",
        options: [],
        name: "preferredcontactmethodcode",
      },
      value: "",
    },
  },
};

export default FormData;
